export default __webpack_public_path__ + "static/media/header-icon.42aa5b65.svg";